import { createDecorator } from 'monaco-editor/esm/vs/platform/instantiation/common/instantiation.js';
const TimelinePaneId = 'timeline';
const TIMELINE_SERVICE_ID = 'timeline';
const ITimelineService = ( createDecorator(TIMELINE_SERVICE_ID));
export { ITimelineService, TimelinePaneId };
